import { useState, useEffect } from "react";
import Button from "../../../components/base/Button";
import { Link } from "react-router-dom";

type HeroMedia =
  | {
      type: "video";
      src: string;
      poster: string;
    };

export default function HeroSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const heroVideos: HeroMedia[] = [
    {
      type: "video",
      src: "https://res.cloudinary.com/dg758eb9e/video/upload/v1779756631/Yoga_7_Promo_video_nwzc8t.mov",
      poster:
        "https://res.cloudinary.com/dg758eb9e/image/upload/v1779762662/494824bb-f773-478f-b380-987ddc58a116.png",
    },
     
    {
      type: "video",
      src: "https://res.cloudinary.com/dg758eb9e/video/upload/v1779756434/video1_paqwrn.mov",
      poster:
        "https://res.cloudinary.com/dg758eb9e/image/upload/v1779762629/ef622b0a-9d2c-41d6-aa0d-ca6ffa0a2db1.png",
    },
    {
      type: "video",
      src: "https://res.cloudinary.com/dg758eb9e/video/upload/v1779756817/Sound_Bath_Video_jcl0i8.mov",
      poster:
        "https://res.cloudinary.com/dg758eb9e/image/upload/v1779762685/180dbc33-0e60-4e1c-b236-45e0cf3ff397.png",
    },
  ];

  const total = heroVideos.length;

  const activeItem =
    activeIndex !== null ? heroVideos[activeIndex] : null;

  const openAt = (index: number) => setActiveIndex(index);
  const close = () => setActiveIndex(null);

  const goNext = () => {
    setActiveIndex((prev) =>
      prev === null ? null : (prev + 1) % total
    );
  };

  const goPrev = () => {
    setActiveIndex((prev) =>
      prev === null ? null : (prev - 1 + total) % total
    );
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (activeIndex === null) return;

      if (e.key === "Escape") close();
      if (e.key === "ArrowRight") goNext();
      if (e.key === "ArrowLeft") goPrev();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [activeIndex]);

  const handleBookClass = () => {
    window.location.href = "/schedule";
  };

  return (
    <div>
      <div className="bg-[#FBF7F7] flex-grow justify-items-center sm:flex-row md:px-24 sm:px-0 justify-center gap-4 lg:gap-16 md:gap-8 pt-6">
        <Link to="https://yogaseven.com/buy-now?_mt=%2Fbuy%2F48717">
          <picture className="block cursor-pointer m-auto mb-4 overflow-hidden">
            <source
              media="(max-width: 768px)"
              srcSet="https://res.cloudinary.com/dg758eb9e/image/upload/v1782256693/photo_2026-06-23_14.51.29_bkih8m.jpg"
            />

            <img
              src="https://res.cloudinary.com/dg758eb9e/image/upload/v1782253548/photo_2026-06-23_14.51.01_dhn1ha.jpg"
              alt="Presale banner"
              className="w-full max-w-[768px] md:max-w-[1275px] h-auto max-h-[500px] m-auto object-contain md:max-h-none md:rounded-3xl"
            />
          </picture>
        </Link>

        <div className="text-left mt-8 max-w-7xl mx-auto pb-8 px-8 md:px-0">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 leading-tight text-[#00889D]">
            Hot Yoga & Fitness Fusion Studio
          </h1>

          <div className="font-bold pb-3">
            Where heat fuels movement and movement fuels transformation
          </div>

          <div>
            This is a space where everyone can find something they love — from Bikram Style Yoga and Vinyasa Flow to Yin Yoga, Pilates, Fitness & Fusion classes, as well as deeply restorative Sound Bath experiences. All classes take place in a warm, cozy studio with gentle <a className="text-blue-600 underline" href="https://yogaseven.com/far-infrared-heat">Far Infrared (FIR)</a> heat designed to help relax muscles, improve flexibility, and create the perfect balance of movement, energy, and restoration.
          </div>

          {/* VIDEOS GRID */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10 justify-items-center">
  {heroVideos.map((video, index) => (
    <div
      key={index}
      onClick={() => openAt(index)}
      className="relative w-full max-w-[300px] rounded-[22px] overflow-hidden bg-white shadow-md cursor-pointer group"
    >
      <video
        src={video.src}
        poster={video.poster}
        muted
        playsInline
        preload="metadata"
        className="w-full h-auto object-cover transition-transform duration-500 scale-105 group-hover:scale-110"
      />

      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition" />
    </div>
  ))}
</div>
        </div>
      </div>

      {/* BUTTONS */}
      <div className="flex flex-col sm:flex-row sm:mt-12 px-6 md:px-24 sm:px-0 justify-center gap-4 lg:gap-16 md:gap-8 mt-6">
        <Link to="/book-now">
          <Button
            size="lg"
            variant="green"
            onClick={handleBookClass}
            className="whitespace-nowrap py-4 rounded-full"
          >
            Book a Class
          </Button>
        </Link>

        <Link to="/classes">
          <Button
            size="lg"
            variant="green"
            className="whitespace-nowrap px-8 py-4 rounded-full"
          >
            Explore Classes
          </Button>
        </Link>

        <Link to="/schedule">
          <Button
            size="lg"
            variant="green"
            className="whitespace-nowrap px-8 py-4 rounded-full"
          >
            See Schedule
          </Button>
        </Link>
      </div>

      {/* LIGHTBOX (same behavior as StudioContentSection) */}
      {activeItem && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={close}
        >
          {/* CLOSE */}
          <button
            className="absolute top-6 right-6 text-white text-4xl font-bold"
            onClick={close}
          >
            ×
          </button>

          {/* LEFT */}
          <button
            className="absolute left-6 text-white text-5xl select-none"
            onClick={(e) => {
              e.stopPropagation();
              goPrev();
            }}
          >
            ‹
          </button>

          {/* RIGHT */}
          <button
            className="absolute right-6 text-white text-5xl select-none"
            onClick={(e) => {
              e.stopPropagation();
              goNext();
            }}
          >
            ›
          </button>

          {/* MEDIA */}
          <div
            className="max-w-4xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <video
              src={activeItem.src}
              poster={activeItem.poster}
              controls
              autoPlay
              className="w-full max-h-[85vh] rounded-xl"
            />
          </div>
        </div>
      )}
    </div>
  );
}